import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const postIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" fill-rule="nonzero" d="M30.254 41v-6.094h1.558c2.125 0 3.764-.488 4.917-1.465 1.152-.976 1.728-2.386 1.728-4.23 0-1.773-.541-3.107-1.623-4.002-1.082-.895-2.662-1.342-4.74-1.342H26.62V41h3.633zm1.195-9.07h-1.195v-5.086h1.652c.992 0 1.721.203 2.186.61.465.405.697 1.034.697 1.886 0 .844-.277 1.486-.832 1.928-.555.441-1.39.662-2.508.662z"/></svg>`
);
